import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { logoutAuthLogoutPost } from "@/api-v3";
import StorageManager from "@/features/storage";
import { reset } from "@/store";

export const useLogout = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useCallback(async () => {
    logoutAuthLogoutPost().catch(() => undefined);
    await reset();
    queryClient.clear();
    StorageManager.clear();
    navigate("/login");
  }, [navigate, queryClient]);
};
